import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { EmperorUIAlertType } from '@boldpenguin/emperor-presentational';
import { Store } from '@ngrx/store';
import { NavigateToComplianceForm } from 'src/app/core/store/compliance-form/compliance-form.actions';

@Component({
  selector: 'app-compliance-alert',
  templateUrl: './compliance-alert.component.html',
  styleUrls: ['./compliance-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComplianceAlertComponent {
  store = inject(Store);
  router = inject(Router);
  readonly EmperorUIAlertType = EmperorUIAlertType;

  navigateToCompliance() {
    this.store.dispatch(NavigateToComplianceForm());
  }
}
